import {
    GET_DISTRICT_DEFINITIONS,
    GET_DISTRICT_DEFINITIONS_SUCCESS,
    ADD_DISTRICT_DEFINITION,
    ADD_DISTRICT_DEFINITION_SUCCESS,
    UPDATE_DISTRICT_DEFINITION,
    UPDATE_DISTRICT_DEFINITION_SUCCESS,
    DELETE_DISTRICT_DEFINITION,
    DELETE_DISTRICT_DEFINITION_SUCCESS,
    DISTRICT_API_ERROR
  } from "./actionTypes"
  
  
  
  
  export const getDistrictDefinition = () => ({
    type: GET_DISTRICT_DEFINITIONS,
  })
  
  export const getDistrictDefinitionSuccess = record => ({
    type: GET_DISTRICT_DEFINITIONS_SUCCESS,
    payload: record,
  })
  
  export const addDistrictDefinition = record => ({
    type: ADD_DISTRICT_DEFINITION,
    payload: record,
  })
  
  export const addDistrictDefinitionSuccess = record => ({
    type: ADD_DISTRICT_DEFINITION_SUCCESS,
    payload: record,
  })
  
  
  export const updateDistrictDefinition = record => ({
    type: UPDATE_DISTRICT_DEFINITION,
    payload: record,
  })
  
  export const updateDistrictDefinitionSuccess = record => ({
    type: UPDATE_DISTRICT_DEFINITION_SUCCESS,
    payload: record,
  })
  
  
  export const deleteDistrictDefinition = guid => ({
    type: DELETE_DISTRICT_DEFINITION,
    payload: guid,
  })
  
  export const deleteDistrictDefinitionSuccess = guid => ({
    type: DELETE_DISTRICT_DEFINITION_SUCCESS,
    payload: guid,
  })
  
  export const districtError = error => {
    return {
      type: DISTRICT_API_ERROR,
      payload: error,
    }
  }
  
  